import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$db4b from '/home/forge/meidenvanholland.nl/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as ipxRuntime$ad21 from '/home/forge/meidenvanholland.nl/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "webp_85": {
      "modifiers": {
        "format": "webp",
        "quality": 85
      }
    },
    "webp_70": {
      "modifiers": {
        "format": "webp",
        "quality": 70
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "cdndo.sysero.nl",
    "images.islive.nl"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$db4b, defaults: {} },
  ['ipx']: { provider: ipxRuntime$ad21, defaults: {} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
